/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Trust_Experience_DescInputs */

const en_home_trust_experience_desc = /** @type {(inputs: Home_Trust_Experience_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trusted since 1989`)
};

const fr_home_trust_experience_desc = /** @type {(inputs: Home_Trust_Experience_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiables depuis 1989`)
};

/**
* | output |
* | --- |
* | "Trusted since 1989" |
*
* @param {Home_Trust_Experience_DescInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_trust_experience_desc = /** @type {((inputs?: Home_Trust_Experience_DescInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Trust_Experience_DescInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_trust_experience_desc(inputs)
	return fr_home_trust_experience_desc(inputs)
});